// Relative path keeps requests same-origin so they work on both
// kautix.com and ayesalon.com without CORS or CSP (connect-src) changes.
export const API_BASE_URL = "/api/";
